module.exports = __webpack_public_path__ + "res/27-img_bg_l.693d2f8574a325d6ac9aeb7b458b95f2.png";